import {RootState} from '../../store';
import {Meter} from './types';

export const selectionSelector = (state: RootState): Record<string, Meter> =>
    state['meters'].selection as Record<string, Meter>;
